module.exports = __webpack_public_path__ + "media/images/top/contents_m_bg-a0acbfcdbdea1aa9ca2bd7e6ac338ac5.gif";